import { render, staticRenderFns } from "./Hand.vue?vue&type=template&id=1bb6132e&scoped=true&"
import script from "./Hand.vue?vue&type=script&lang=js&"
export * from "./Hand.vue?vue&type=script&lang=js&"
import style0 from "./Hand.vue?vue&type=style&index=0&id=1bb6132e&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1bb6132e",
  null
  
)

export default component.exports